<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center
            >Invoice Shipping Line Payment Details (Freight)</b-navbar-brand
          >
        </b-navbar>

        <div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5>
        </div>
        <div>
          <b-form-group>
            <b-input-group>
              <b-form-input :formatter="capitalizeAll"
                v-model="filter"
                @input="debounceSearch"
                placeholder="Type To Search  (Assignment No. / Client / BL )"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filterClear"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <md-layout md-gutter>
            <b-button
              v-b-modal.modal-prevent-closing
              size="sm"
              variant="outline-primary"
              >Bulk Update</b-button
            >

            <div class="ml-3 mt-2">
              <!-- <h5> -->
                <b-badge
                style="padding: 8px"
                href="#"
                @click="getShippingLineFilterbtn('28')"
                variant="warning"
                >HAMBURG SÃD INDIA PRIVATE LIMITED</b-badge
              >
              <!-- </h5> -->
              <b-badge
              style="padding: 8px"
                href="#"
                @click="getShippingLineFilterbtn('17')"
                variant="warning"
                >MSC AGENCY (INDIA) PRIVATE LIMITED</b-badge
              >
              <b-badge
              style="padding: 8px"
                href="#"
                @click="getShippingLineFilterbtn('13')"
                variant="warning"
                >MAERSK LINE INDIA PVT. LTD</b-badge
              >
              <b-badge
              style="padding: 8px"
                href="#"
                @click="getShippingLineFilterbtn('')"
                variant="danger"
                >Clear All</b-badge
              >
            </div>

            <md-layout md-flex="15"></md-layout>

            <md-layout md-flex="15" class="mr-2">
              <model-list-select
                @input="getShippingLineFilter"
                v-model="shipplingFilter"
                :list="shipplingLineList"
                option-value="shippingId"
                option-text="shippingLine"
                placeholder="Select Shipping Line"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="15">
              <model-list-select
                @input="viewFFExportFCL('0', '0', '1', '1')"
                :list="payList"
                v-model="donePendingFilter"
                option-value="payVal"
                option-text="payText"
                placeholder="Select "
              ></model-list-select>
            </md-layout>
            <b-button
              class="pull-right ml-2"
              @click="getReports"
              size="sm"
              variant="outline-primary"
              >Export as Excel</b-button
            >

            <b-button
              v-if="selected.length > 0"
              class="pull-right ml-2"
              @click="sendRequest"
              size="sm"
              variant="outline-danger"
              >Send Request</b-button
            >
          </md-layout>
        </div>

        <!-- Main table element -->
        <div class="table-responsive tableMain mt-2">
          <b-table
            show-empty
            stacked="md"
            :items="FFExport"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :select-mode="selectMode"
            ref="selectableTable"
            selectable
            @row-selected="onRowSelected"
          >
            <!-- <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
                </template>
            </template> -->
            <template slot="isPayActive" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="ffExportFclSeries" slot-scope="row11">
              <div>
                <!-- <div
                      v-if="(row11.item.toSplitAssignmentNo!=null  || row11.item.toMergeAssignmentNo!=null)"
                    >
                      <span>
                        <b-badge variant="danger">ASSIGNMENT CLOSED</b-badge>
                      </span>
                      <br>
                      <span>Assignment No. : {{row11.item.ffExportFclSeries}}</span>
                      <br>
                      <span>Assignment Date : {{row11.item.loginTime | moment}}</span>
                      <br>
                      <span>Raised From : {{row11.item.EmpLoc}}</span>
                </div>-->
                <!-- v-else -->
                <!-- :style="row11.item.seenExec=='0'?'color:red':'color:black'"
                @click="freight==true?viewExportFCLPage(row11.item):''"-->
                <div>
                  <span>
                    <h6 v-if="row11.item.seenExec == '0'">
                      <b-badge variant="success">New</b-badge>
                    </h6>
                    <b>  {{row11.item.ffExportFclSeries ? row11.item.ffExportFclSeries : row11.item.mainSalesSeries }}</b>
                  </span>

                  <br />
                  <span
                    >Assignment. Dt. : {{row11.item.asignDate ? row11.item.asignDate : row11.item.mainAssignDate}}</span
                  >
                  <br />
                  <!-- <span>Raised From : {{row11.item.EmpLoc}}</span> -->
                </div>
              </div>
            </template>
             <template slot="clientName" slot-scope="row2">
              
                  <span
                   
                  >
                  {{row2.item.clientName ? row2.item.clientName : row2.item.mainClientName }}

                  </span>
               
            

             
            </template>

            <template slot="shippingLine" slot-scope="row3">
              
                  <span
                  >
                  {{row3.item.shippingLine ? row3.item.shippingLine : row3.item.mainShippingLine }}

                  </span>
             
            </template>
            <template slot="invoiceAmount" slot-scope="row5">
              <div
                v-if="
                  row5.item.invoiceList != null &&
                  row5.item.invoiceList.length > 0
                "
              >
                <span
                  v-for="(item2, index) in row5.item.invoiceList"
                  :key="index"
                >
                  <!-- Invoice no : {{item2.invNo}}<br>
                  Invoice type : {{item2.invType}}<br> -->
                  Invoice Amount : {{ item2.invAmount }}<br />
                  <hr style="margin: 3px !important; color: red" />
                </span>
                <hr style="margin: 3px !important; color: red" />
                Due Date <br />
                {{ row5.item.dueDate ? row5.item.dueDate.split(" ")[0] : "--" }}
              </div>
              <div v-else>
                <span>
                  Invoice Amount <br />
                  {{ row5.item.invoiceAmount }}
                  <hr style="margin: 3px !important; color: red" />
                  Due Date <br />
                  {{
                    row5.item.dueDate ? row5.item.dueDate.split(" ")[0] : "--"
                  }}
                </span>
              </div>
            </template>
            <template slot="freightContainersType" slot-scope="row50">
              <div v-if="row50.item.freightContainersType != null">
                <div v-if="row50.item.freightContainersType != null">
                  <span
                    v-for="(
                      item2, index
                    ) in row50.item.freightContainersType.split(',')"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light">{{
                        item2 == "" ? "-------" : item2
                      }}</b-badge>
                    </h6>
                  </span>
                </div>
              </div>
              <div v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
              <div
                v-if="
                  (row50.item.toSplitAssignmentNo != null ||
                    row50.item.toMergeAssignmentNo != null) &&
                  row50.item.containerLeft == 0
                "
              >
                All Containers has been merged or splited to another
                Assignment..!
              </div>
            </template>
            <template slot="placeRecp" slot-scope="row10">
              <span>POR :- {{ row10.item.placeRecp }}</span>
              <br />
              <span>LP :- {{ row10.item.LoadPort }}</span>
              <br />
              <span>POD :- {{ row10.item.placeDis }}</span>
              <br />
              <span>FPOD :- {{ row10.item.finalPlace }}</span>
              <br />
            </template>

            <template slot="asignDate" slot-scope="row3">
              <b-button
                v-if="accounts == true"
                @click="goToSlinePay(row3.item)"
                size="sm"
                variant="outline-danger"
                >Sline Payment</b-button
              ><br />
              <b-badge
                variant="warning"
                v-if="
                  row3.item.totalAmount != '' && row3.item.totalAmount != null
                "
                >Payment completed</b-badge
              >
              <b-badge
                variant="warning"
                v-else-if="
                  row3.item.invStatus != null && row3.item.invStatus == '2'
                "
                >Payment completed</b-badge
              >
              <b-badge variant="danger" v-else>Payment pending</b-badge>
              <br />
              <b-badge
                variant="warning"
                v-if="row3.item.suplimentaryInvCount > 0"
                >Supplementary Inv Payment Pending</b-badge
              >

              <!-- <b-dropdown

                      @click="viewFFExportFCL"
                      right
                      size="sm"
                      variant="outline-success"
                      id="dropdown-1"
                      text="GO TO"
                      class="m-md-2"
                    >
                      <b-dropdown-item
                        :disabled="bookPageId=='0'?true:false"
                        @click="gotToPage('BOOK')"
                      >Booking</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="execPageId=='0'?true:false"
                        @click="gotToPage('EXEC')"
                      >Execution</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="vgmPageId=='0'?true:false"
                        @click="gotToPage('VGM')"
                      >VGM</b-dropdown-item>

                      <b-dropdown-item
                        :disabled="handoverPageId=='0'?true:false"
                        @click="gotToPage('HAND')"
                      >Handover & Rail-Out</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="sailPageId=='0'?true:false"
                        @click="gotToPage('SAIL')"
                      >Sail & FPOD</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="ladingPageId=='0'?true:false"
                        @click="gotToPage('LADING')"
                      >Bill Of Lading</b-dropdown-item>
              </b-dropdown>-->
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination
                limit="25"
                align="center"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>
    <b-modal
      id="modal-multi-3"
      hide-footer
      ref="confirmModal"
      title="Confirmation"
    >
      <p class="my-1">
        {{
          mergeModal.actionType == "2"
            ? "Are you sure you want to Split this Assignment..!"
            : "Are you sure you want to Merge containers of this Assignment to selected Assignment..!"
        }}
      </p>
      <div>
        <b-button
          class="mt-3 pull-right"
          variant="outline-danger"
          @click="closeDialogConfirm"
          >Cancel & Close</b-button
        >
        <b-button class="mt-3" variant="outline-primary" @click="onCloseSubmit"
          >Yes</b-button
        >
      </div>
    </b-modal>
    <div>
      <b-modal
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        scrollable
        id="myDIV"
        hide-footer
        ref="splitMergePop"
        :title="
          mergeModal.actionType == '2'
            ? 'Assignment Split Utility'
            : 'Assignment Merge Utility'
        "
      >
        <div class="d-block text-center">
          <b-card>
            <b-card-text>
              <div>
                <md-layout md-gutter>
                  <md-layout md-flex="20">
                    <label>Action</label>
                    <model-list-select
                      isDisabled
                      @input="getSplitAssignment"
                      :list="actionList"
                      id="actionType"
                      v-model="mergeModal.actionType"
                      option-value="aV"
                      option-text="aT"
                      placeholder="Select Action "
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="75" v-if="mergeModal.actionType == '2'">
                    <label>Assignment No.</label>
                    <model-list-select
                      @input="getTomergeExecId"
                      :list="
                        mergeModal.actionType == '1'
                          ? toMergeAssignmentList
                          : dummySplitAssignment
                      "
                      id="clientId"
                      v-model="mergeModal.ffExportFclIdContainer"
                      option-value="ffExportFclId"
                      option-text="ffExportFclSeries"
                      placeholder="Select Assignment "
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <b-container
                  class="gutr"
                  fluid
                  v-if="mergeModal.actionType == '1'"
                >
                  <b-card>
                    <!-- User Interface controls -->
                    <b-row>
                      <b-col md="12" class="my-1">
                        <b-form-group>
                          <b-input-group>
                            <b-form-input :formatter="capitalizeAll"
                              v-model="filter1"
                              placeholder="Type To Search"
                            />
                            <b-input-group-append>
                              <b-button
                                :disabled="!filter1"
                                @click="filter1 = ''"
                                >Clear</b-button
                              >
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Main table element -->
                    <b-table
                      show-empty
                      stacked="md"
                      :items="toMergeAssignmentList"
                      :fields="fields1"
                      :current-page="currentPage1"
                      :per-page="perPage1"
                      :filter="filter1"
                      :sort-by.sync="sortBy1"
                      :sort-desc.sync="sortDesc1"
                      :sort-direction="sortDirection1"
                      @filtered="onFiltered1"
                    >
                      <template slot="ffExportFclId" slot-scope="row0">
                        <span>{{
                          row0.index + 1 + (currentPage1 - 1) * perPage1
                        }}</span>
                      </template>

                      <template slot="asignDate" slot-scope="row1">
                        <b-form-radio
                          @change="onRadioMerge(row1.item.ffExportFclId)"
                          v-model="mergeModal.ffExportFclIdContainer"
                          name="some-radios"
                          :value="row1.item.ffExportFclId"
                          >Select</b-form-radio
                        >
                      </template>
                    </b-table>

                    <b-row>
                      <b-col md="12" class="my-1">
                        <b-pagination
                          limit="25"
                          :total-rows="totalRows1"
                          :per-page="perPage1"
                          v-model="currentPage1"
                          class="my-0 pull-right"
                        />
                      </b-col>
                    </b-row>
                  </b-card>
                </b-container>
                <div class="box" v-if="FFExportContainers.length > 0">
                  <!-- <div class="box-header">
                      <h3 class="box-title"></h3>
                  </div>-->
                  <!-- /.box-header -->
                  <b-card class="gutr">
                    <div class="box-body gutr">
                      <table id="po" class="table">
                        <thead>
                          <tr>
                            <th>Sr no</th>
                            <!-- <th>Assignment No.</th> -->
                            <th>Container No.</th>
                            <th>Net Weight</th>
                            <th>Gross Weight</th>
                            <th>Custom Seal No.</th>
                            <th>Line Seal No.</th>
                            <th>Select</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            :style="
                              item1.seenExec == '0'
                                ? 'color:red'
                                : 'color:black'
                            "
                            v-for="(item1, index) in FFExportContainers"
                            :key="index"
                          >
                            <td>{{ index + 1 }}</td>

                            <!-- <td>{{item1.ffExportFclSeries}}</td> -->
                            <td>
                              <span>Container No. :</span>
                              <span class="mainClick">{{
                                item1.containerNo
                              }}</span>
                              <br />
                              <span>Container Type :</span>
                              <span class="mainClick">{{
                                item1.containerType
                              }}</span>
                            </td>
                            <td>{{ item1.netWeight }}{{ item1.weightUnit }}</td>
                            <td>
                              {{ item1.grossWeight }}{{ item1.weightUnit }}
                            </td>
                            <td>{{ item1.customSealNo }}</td>
                            <td>{{ item1.LineSealNo }}</td>
                            <td>
                              <md-checkbox
                                class="md-primary"
                                style="margin: 0px"
                                @change="getMergeContainerData(item1, index)"
                                v-bind:class="
                                  mergeFclContainers.indexOf(
                                    item1.ffExportFclId
                                  ) >= 0
                                    ? 'md-checked checkedNew' +
                                      item1.ffExportFclId +
                                      (index + 1)
                                    : 'checkedNew' +
                                      item1.ffExportFclId +
                                      (index + 1)
                                "
                                :md-value="item1.ffExportFclId"
                                :name="'deptMas' + (item1.ffExportFclId + 1)"
                                :id="'deptMas' + (item1.ffExportFclId + 1)"
                              ></md-checkbox>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card>

                  <div class="gutr">
                    <b-button
                      variant="primary"
                      class="pull-right"
                      @click="mergeSubmit"
                      >Submit</b-button
                    >
                    <b-button
                      variant="outline-danger"
                      class="pull-right"
                      @click="closeMerge"
                      >Close</b-button
                    >
                  </div>

                  <!-- /.box-body -->
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </b-modal>
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        size="lg"
        id="modal-prevent-closing"
        ref="modalBulk"
        title="Submit Your Name"
        @ok="handleOk"
      >
        <h4>Bulk Update Shipping Line Payment</h4>
        <br />
        <form ref="form">
          <div>
            <!-- Styled -->
            <div>
              <h4 class="error">{{ ShowMsg }}</h4>
            </div>

            <b-form-file
              v-model="fileUpload"
              placeholder="Choose a file ..."
            ></b-form-file>
            <div class="mt-3">
              Selected file: {{ fileUpload ? fileUpload.name : "" }}
            </div>
          </div>
        </form>
      </b-modal>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseSubmit"
      ref="addPopSubmit"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";

export default {
  beforeMount() {
    this.getShippingList();
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/slinePay");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      fileUpload: "",
      excelUpload: "",
      shipplingFilter: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      donePendingFilter: "2",
      shipplingLineList: [],
      payList: [
        {
          payVal: "0",
          payText: "All",
        },
        {
          payVal: "1",
          payText: "Completed",
        },
        {
          payVal: "2",
          payText: "Pending",
        },
      ],
      fields: [
        //   {
        //   key: "selected",
        //   label: "Selected",

        // },
        {
          key: "isPayActive",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "invNo",
          label: "Invoice No.",
        },
        {
          key: "ffExportFclSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "clientName",
          label: "Client / Exporter Name",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "invType",
          label: "Invoice Type.",
        },

        // {
        //   key: "freightContainers",
        //   label: "Container No.",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },
        // {
        //   key: "freightContainersType",
        //   label: "Container Type",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },

        {
          key: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "SlineBlNo",
          mainkey: "SlineBlNo",
          label: "BL No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "invoiceAmount",
          mainkey: "invoiceAmount",
          label: "Other",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "asignDate",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },
      ],
      currentPage: 1,
      perPage: 30,
      totalRows: 1000000000000000,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      fields1: [
        {
          key: "ffExportFclId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ffExportFclSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "freightContainers",
          label: "Container No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loginTime",
          label: "Select Assignment",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      selectedTomerge: "",
      currentPage1: 1,
      perPage1: 2,
      totalRows1: "",
      pageOptions1: [5, 10, 15],
      sortBy1: null,
      sortDesc1: false,
      sortDirection1: "desc",
      filter1: null,
      modalInfo1: { title: "", content: "" },
      filtrActive: 0,
      accounts: globalPermissionStatus("Accounts"),
      freight: globalPermissionStatus("Sea Freight"),
      routePageId: "",
      isLoading: false,
      totalCount: "",
      totalCompleted: "",
      totalVGMSubCount: "",
      totalGateInCount: "",
      totalHandoverCount: "",
      totalRailCount: "",
      totalSailCount: "",
      totalSICount: "",
      totalBLCount: "",
      bookPageId: "",
      execPageId: "",
      vgmPageId: "",
      handoverPageId: "",
      sailPageId: "",
      ladingPageId: "",

      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      FFExport: [],
      FFExportNew: [],

      selectMode: "multi",
      selected: [],
      sendMail: false,
      // Modal
      mergeModal: {
        allModuleId: "",
        splitContainerCount: "",
        splitContainer: "",
        actionType: "",
        noOfContainers: "",
        conTypeIdForEnq: "",
        conTypeForEnq: "",
        mainffId: "",
        clientId: "",
        ffExportFclId: "",
        ffExportFclIdContainer: "",
        toMergeffExecutionId: "",
        mainEnquiryId: "",
        containerTypeIdQuotation: "",
        containerTypeQuotation: "",
        toMergeEnquiryId: "",
        ffShippingWiseId: "",
      },
      actionList: [
        { aV: "1", aT: "Merge" },
        { aV: "2", aT: "Split" },
      ],
      mergeFclContainers: [],
      mergerContainerTypeQuot: [],
      containerCountType: [],
      clientList: [],
      assigmnmentList: [],
      toMergeAssignmentList: [],
      dummySplitAssignment: [],
      showAssignmentTable: false,
      debounce: null,
      asignmentSeriesCount: "",
      ShowMsg: "",
      showContainerTable: true,
      FFExportContainers: [],
      allClientContainerData: [],
      ffAssignmentQuotation: [],
      countArry: [],
      containerList: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sortOptions1() {
      // Create an options list from our fields
      return this.fields1
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    milestoneFiltersD: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },
  methods: {
    getShippingLineFilterbtn(index) {
      this.shipplingFilter = index;
      console.log("Filter => ", this.shipplingFilter);
      this.viewFFExportFCL("0", "0", "1", "1", this.shipplingFilter);
    },
    getShippingLineFilter() {
      console.log("Filter => ", this.shipplingFilter);
      this.viewFFExportFCL("0", "0", "1", "1", this.shipplingFilter);
    },
    onRowSelected(items) {
      this.selected = items;
    },
    sendRequest() {
      let send_request = {
        requestId: "SLINE",
        selectedInvoices: this.selected,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingSeaExport/slinePaymentInvoiceRequest.php`,
        data: JSON.stringify(send_request),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {});
    },

    getShippingList() {
      let send_request = {
        requestId: "SLINE",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingSeaExport/shipplingLineList.php`,
        data: JSON.stringify(send_request),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("shipping line => ", data);
            this.shipplingLineList = data.data;
          }
        })
        .catch((error) => {});
    },
    getReports() {
      let view_Assignment = {
        excelId: "SLINE",
        donePendingFilter: this.donePendingFilter,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingSeaExport/excelExportSlinePayment.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            window.location.href =
              `https://uploadsp.pridel.com/Pridel_Reports/` +
              data.excelName;

            //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

            // console.log(abc)
          }
        })
        .catch((error) => {});
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`slinePayment[]`, files[i]);
        console.log(files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      return false;
      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.getData();
        })
        .catch((err) => {
          throw err;
        });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      var files = this.fileUpload;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      formData.append(`slinePayment[]`, files);

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
            this.$refs["addPop"].open();
          } else {
            this.ShowMsg = "Uploaded";
          }

          this.fileUpload = "";
          //this.$bvModal.hide('modal-prevent-closing')

          this.getData();
        })
        .catch((err) => {
          throw err;
        });
      // Trigger submit handler
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL("0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/freightForwarding/ffDocListPage/" + ID + "/Export",
      });
    },
    gotToPage(ID) {
      if (ID == "BOOK") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);

        this.$router.push({
          path: "/freightForward/ffBooking",
        });
      } else if (ID == "EXEC") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        if (this.ffExoprtDetail.stuffingType == "factoryStuffing") {
          this.$router.push({
            path: "/freightForward/ffExecution",
          });
        } else {
          this.$router.push({
            path: "/freightForward/ffexecutionWareHouse",
          });
        }
      } else if (ID == "VGM") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/vgmDetail",
        });
      } else if (ID == "HAND") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/handoverToRail",
        });
      } else if (ID == "SAIL") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/sailFPOD",
        });
      } else if (ID == "LADING") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/fclBLofLanding",
        });
      }
    },
    onRadioMerge(id) {
      this.mergeModal.ffExportFclIdContainer = id;
      this.getTomergeExecId();
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // Modal
    getMergeContainerData(item, index) {
      let i = this.mergeFclContainers.indexOf(item);

      // let i = this.mergeFclContainers.findIndex(z => {
      //   return z.ffExecutionContainerId == z.ffExecutionContainerId;
      // });

      // return false;

      if (i >= 0) {
        this.mergeFclContainers.splice(i, 1);
        this.mergerContainerTypeQuot.splice(i, 1);
        this.containerCountType.splice(i, 1);
      } else {
        this.mergeFclContainers.push(item);
        this.mergerContainerTypeQuot.push(item.containerTypeId);
        this.containerCountType.push(item.containerType);
      }

      this.containerList = [];
      this.mergeFclContainers.map((x) => {
        let obj = {
          containerType: x.containerType,
          containerTypeId: x.containerTypeId,
          subtractContainerId: x.ffConId,
          count: 1,
        };

        let arrayCheck = this.containerList.findIndex((y) => {
          return y.containerTypeId == x.containerTypeId;
        });
        if (arrayCheck >= 0) {
          this.containerList[arrayCheck]["count"] =
            this.containerList[arrayCheck]["count"] + 1;
        } else {
          this.containerList.push(obj);
        }
      });

      this.mergeModal["containerTypeIdQuotation"] =
        this.mergerContainerTypeQuot.join();
      this.mergeModal["containerTypeQuotation"] =
        this.containerCountType.join();

      this.mergeModal.containerTypeIdQuotation = Array.from(
        new Set(this.mergeModal.containerTypeIdQuotation.split(","))
      ).toString();

      this.mergeModal.containerTypeQuotation = Array.from(
        new Set(this.mergeModal.containerTypeQuotation.split(","))
      ).toString();

      this.mergeModal.conTypeIdForEnq =
        "," + this.mergeModal.containerTypeIdQuotation;
      this.mergeModal.conTypeForEnq =
        "," + this.mergeModal.containerTypeQuotation;

      var counts = {};
      this.containerCountType.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
      });

      this.countArry = Object.values(counts);
      this.mergeModal["noOfContainers"] = "," + this.countArry.join();
      this.getTomergeExecId();
    },
    getSplitMergeData(filterIdD) {
      this.routePageId = filterIdD;
      $("#po").DataTable().destroy();
      if (this.mergerContainerTypeQuot.length <= 0) {
        this.FFExportContainers = [];
      }
      this.isLoading = true;
      let payload = {
        view: "view",
        DCfilterId: filterIdD,
        clientId: this.mergeModal.clientId,
        ffExportFclId: this.mergeModal.ffExportFclId,
        ffExportFclIdContainer: this.mergeModal.ffExportFclIdContainer,
        mainEnquiryId: this.mergeModal.mainEnquiryId,
        allModuleId: this.mergeModal.allModuleId,
        containerTypeIdQuotation: this.mergeModal.containerTypeIdQuotation,
        //   actionType: this.mergeModal.actionType
      };
      //  console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewMergeContainerTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.ffExportContainerData.length > 0) {
              this.FFExportContainers = data.ffExportContainerData;
            } else {
              this.FFExportContainers = [];
            }
            if (data.allClientContainerData.length > 0) {
              this.allClientContainerData = data.allClientContainerData;
            } else {
              this.allClientContainerData = [];
            }

            if (data.ffAssignmentQuotation.length > 0) {
              this.ffAssignmentQuotation = data.ffAssignmentQuotation;
            } else {
              this.ffAssignmentQuotation = [];
            }

            this.asignmentSeriesCount = data.asignmentSeriesCount;

            if (data.clientdetail.length > 0) {
              this.clientList = data.clientdetail;
            } else {
              this.clientList = [];
            }
            if (data.fromMergeAssignmentList.length > 0) {
              this.assigmnmentList = data.fromMergeAssignmentList;
            } else {
              this.assigmnmentList = [];
            }

            if (data.toMergeAssignmentList.length > 0) {
              this.toMergeAssignmentList = data.toMergeAssignmentList;

              this.totalRows1 = this.toMergeAssignmentList.length;
              // this.mergeModal.toMergeffExecutionId =
              //   data.toMergeAssignmentList[0].ffExecutionId;
            } else {
              this.toMergeAssignmentList = [];
            }

            // this.JqueryFun();
            this.dataOnFromAssignment();
            this.getSplitAssignment();

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getSplitAssignment() {
      if (this.mergeModal.actionType == "2") {
        this.dummySplitAssignment = [];

        let splitArry = this.assigmnmentList.filter((x) => {
          return x.ffExportFclId == this.mergeModal.ffExportFclId;
        });

        if (splitArry.length > 0) {
          // alert("split");
          let obj = {
            ffExportFclSeries:
              splitArry[0].ffExportFclSeries + "/A" + this.asignmentSeriesCount,
            ffExportFclId: splitArry[0].ffExportFclId,
          };
          this.dummySplitAssignment.push(obj);
          this.mergeModal.ffExportFclIdContainer =
            this.dummySplitAssignment[0].ffExportFclId;
        }
      }
      // this.viewFFExportFCL();
    },
    dataOnFromAssignment() {
      let EnqIdArry = this.assigmnmentList.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclId;
      });
      if (EnqIdArry.length > 0) {
        this.mergeModal.mainEnquiryId = EnqIdArry[0].mainEnquiryId;
        this.mergeModal.allModuleId = EnqIdArry[0].allModuleId;
      }

      // this.getSplitMergeData();
    },
    getTomergeExecId() {
      let dummyExIdArry = this.allClientContainerData.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclIdContainer;
      });
      console.log(this.mergeModal.ffExportFclIdContainer);
      if (dummyExIdArry.length > 0) {
        console.log(dummyExIdArry, "jjjj");
        this.mergeModal.toMergeffExecutionId = dummyExIdArry[0].ffExecutionId;
        if (this.mergeModal.actionType == "2") {
          //  alert("split");
          this.mergeModal.splitAssignmentSeries =
            dummyExIdArry[0].ffExportFclSeries +
            "/A" +
            this.asignmentSeriesCount;
        } else {
          this.mergeModal.splitAssignmentSeries =
            dummyExIdArry[0].ffExportFclSeries;
        }
      }

      let dummyEnqId = this.toMergeAssignmentList.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclIdContainer;
      });

      if (dummyEnqId.length > 0) {
        this.mergeModal.toMergeEnquiryId = dummyEnqId[0].mainEnquiryId;
        this.mergeModal.mainffId = dummyEnqId[0].mainffId;
        this.mergeModal.ffShippingWiseId = dummyEnqId[0].ffShippingWiseId;
      }
      this.getSplitMergeData();
    },
    showSMModal(item, ID) {
      this.FFExportContainers = [];
      this.mergeModal.allModuleId = item.allModuleId;
      if (ID == "S") {
        this.mergeModal.actionType = "2";
      } else {
        this.mergeModal.actionType = "1";
      }

      this.mergeModal.clientId = item.clientId;
      this.mergeModal.ffExportFclId = item.ffExportFclId;

      this.dataOnFromAssignment(item.ffExportFclId);
      // this.mergeModal.mainEnquiryId=item.,

      this.$refs["splitMergePop"].show();
      this.getSplitMergeData();
    },

    mergeSubmit() {
      this.getSplitMergeData();
      this.$refs["confirmModal"].show();
    },
    closeMerge() {
      this.$refs["splitMergePop"].hide();
    },
    closeDialogConfirm() {
      this.$refs["confirmModal"].hide();
    },
    onCloseSubmit() {
      this.mergeModal["containerList"] = this.containerList;

      this.mergeModal.containerList.map((x) => {
        this.mergeModal.splitContainer += x.containerType + ",";
        this.mergeModal.splitContainerCount += x.count + ",";
      });
      // this.isLoading = true;
      this.mergeModal["mergeFclContainers"] = this.mergeFclContainers;
      this.mergeModal["ffAssignmentQuotation"] = this.ffAssignmentQuotation;

      // return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/addMergeContainers.php`,
        data: JSON.stringify(this.mergeModal),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
            if (data.msg == "Inserted and Updated Successfully") {
              if (this.mergeModal.actionType == "1") {
                this.alert.content = "Container Merged Successfully";
              } else {
                this.alert.content = "Assignment Splited Successfully";
              }
            } else {
              this.alert.content = "Failed To MERGE or SPLIT";
            }
            this.$refs["confirmModal"].hide();

            this.$refs["splitMergePop"].hide();
            this.viewFFExportFCL("0");
            this.$refs["addPop"].open();
          }
        })
        .catch((error) => {});
    },
    // Main Table
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToSlinePay(item) {
      console.log("AllMoudule Id => ",item);
      this.$sessionsStorage.set("editSalesExId", item.allModuleId);
      this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
      if (item.stuffingType == "factoryStuffing") {
        this.$sessionsStorage.set("editFFExecutionId", item.factoryStufExecId);
      } else {
        this.$sessionsStorage.set(
          "editFFExecutionId",
          item.wareHouseStufExecId
        );
      }

      if (item.newSlineFlow == "1") {
       

        if(item.isMiscJob ==1 ){
         this.$sessionsStorage.set("editExportFCLId", "");
          this.$sessionsStorage.set("editFFExecutionId", "");
            this.$router.push({
              path: "/misc/invoiceSlinePayment",
          });
        }else{
          if(item.ON_Type =="New"){
            this.$router.push({
              path: "/freightForward/ffSLinePaymentExportN_VP",
            });
          }else{
            this.$router.push({
              path: "/freightForward/ffSLinePaymentExportNew",
            });
          }
          //  this.$router.push({
          //   // path: "/freightForward/ffSLinePaymentExportNew",
          //   path: "/freightForward/ffSLinePaymentExportN_VP",
          // });
        }
        // this.$router.push({
        //   path: "/freightForward/ffSLinePaymentExportNew",
        // });
      } else {
        this.$router.push({
          path: "/freightForward/ffSLinePaymentExport",
        });
      }
    },
    goToMain() {
      this.$sessionsStorage.set("editExportFCLId", "");
      this.$router.push({
        path: "/freightForward/ffExportFcl",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#po").DataTable();
      });
    },

    viewExportFCLPage(item) {
      let SEEN = item.seenExec;
      let FCLID = item.ffExportFclId;

      if (SEEN != "1") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          ffExportfclId: FCLID,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
            }
          })
          .catch((error) => {});
      }

      let STUFFINGTYPE = item.stuffingType;
      let BOOKINGIDFAC = item.factoryBookingId;
      let FACTORYEXID = item.factoryStufExecId;
      let BOOKINGIDWARE = item.wareHBookingId;
      let WAREHOUSEEXID = item.wareHouseStufExecId;
      let HANDID = item.handoverToRailId;
      let RAILOUTID = item.ffRailOutId;
      let SAILID = item.ffSailId;
      let BLID = item.fclBlId;
      if (this.routePageId == "0" || this.routePageId == "8") {
        this.$sessionsStorage.set("editExportFCLId", FCLID);
        this.$router.push({
          path: "/freightForward/ffExportFcl",
        });
      } else if (
        this.routePageId == "1" ||
        this.routePageId == "2" ||
        this.routePageId == "3" ||
        this.routePageId == "4" ||
        this.routePageId == "5" ||
        this.routePageId == "6" ||
        this.routePageId == "7"
      ) {
        if (STUFFINGTYPE == "factoryStuffing") {
          this.$sessionsStorage.set("editExportFCLId", FCLID);
          this.$sessionsStorage.set("editFFBookingId", BOOKINGIDFAC);
          this.$sessionsStorage.set("editFFExecutionId", FACTORYEXID);
          if (
            this.routePageId == "1" ||
            this.routePageId == "2" ||
            this.routePageId == "6"
          ) {
            this.$router.push({
              path: "/freightForward/ffExecution",
            });
          } else if (this.routePageId == "3" || this.routePageId == "4") {
            this.$router.push({
              path: "/freightForward/handoverToRail",
            });
          } else if (this.routePageId == "5") {
            this.$router.push({
              path: "/freightForward/sailFPOD",
            });
          } else {
            this.$router.push({
              path: "/freightForward/BL-NonUS",
            });
          }
        } else {
          this.$sessionsStorage.set("editExportFCLId", FCLID);
          this.$sessionsStorage.set("editFFBookingId", BOOKINGIDWARE);
          this.$sessionsStorage.set("editFFExecutionId", WAREHOUSEEXID);

          if (
            this.routePageId == "1" ||
            this.routePageId == "2" ||
            this.routePageId == "6"
          ) {
            this.$router.push({
              path: "/freightForward/ffexecutionWareHouse",
            });
          } else if (this.routePageId == "3" || this.routePageId == "4") {
            this.$router.push({
              path: "/freightForward/handoverToRail",
            });
          } else if (this.routePageId == "5") {
            this.$router.push({
              path: "/freightForward/sailFPOD",
            });
          } else {
            this.$router.push({
              path: "/freightForward/BL-NonUS",
            });
          }
        }
      }
    },
    viewFFExportFCL(
      filterIdD,
      CURRENT,
      SEARCH,
      pageNumber,
      shippingFilter = null
    ) {
      this.filtrActive = filterIdD;
      this.routePageId = filterIdD;

      console.log("shipping filter => ", this.shipplingFilter);

      // this.isLoading = true;
      let payload = {
        view: "view",
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        donePendingFilter: this.donePendingFilter,
        shipplingLineFilter: this.shipplingFilter,
      };
      console.log(payload);
      let options = {
        method: "POST",
        // url: `${URL_BASE}/Api_FFSeaExport/getSlinePaymentList1.php`,
        url: `${URL_BASE}/Api_FFSeaExport/getSlinePaymentListMulti.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (
                this.lastVisitPage &&
                this.$sessionsStorage.get("lastVisitPage")
              ) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.ffExportDetails.length > 0) {
              this.FFExport = data.ffExportDetails;
              console.log("test=>", this.FFExport.length);

              this.FFExport.forEach((elementMain) => {
                var invoiceDetails = data.ffSLinePayInvoices.filter(
                  (invIndex) => {
                    return invIndex.ffSlinePayId == elementMain.ffSlinePayId;
                  }
                );

                // console.log("Invoice => ",invoiceDetails);
                if (invoiceDetails.length > 0) {
                  console.log(invoiceDetails.length);
                  var invoiceArray = [];
                  invoiceDetails.forEach((element) => {
                    element["invNo"] = element.ffSlineInvNo;

                    element["invTypeArr"] = JSON.parse(element.ffSlineInvType);
                    element["invType"] = element["invTypeArr"].map(
                      (itm) => itm.text
                    );
                    element["invType"] = element["invType"].toString();

                    element["invAmount"] = "";

                    var invoiceAmount = data.ffSLinePayAmount.filter(
                      (amoIndex) => {
                        return amoIndex.ffSlineInvId == element.ffSlineInvId;
                      }
                    );

                    let invCurrencyList = [];

                    for (var i = 0; i < invoiceAmount.length; i++) {
                      invCurrencyList.push({
                        invAmount: invoiceAmount[i].ffSlineInvAmount || "",
                        invCurrency: invoiceAmount[i].ffSlineInvCurrency || "",
                      });

                      if (
                        invoiceAmount[i].ffSlineInvAmount &&
                        invoiceAmount[i].ffSlineInvCurrency
                      ) {
                        element["invAmount"] +=
                          invoiceAmount[i].ffSlineInvAmount +
                          " " +
                          invoiceAmount[i].ffSlineInvCurrency +
                          ", ";
                      }
                      elementMain["invStatus"] = invoiceAmount[i].ffSlineInvPayStatus;
                    }

                    element["invCurrencyList"] = invCurrencyList;

                    // elementMain['invCurrencyList'] = element;

                    invoiceArray.push(element);

                    elementMain["invNo"] = element.ffSlineInvNo;
                    elementMain["invType"] = element["invType"];
                    elementMain["invAmount"] = element["invAmount"];
                     

                    this.FFExportNew.push(elementMain);
                  });

                  if (invoiceArray.length > 0) {
                    elementMain["invoiceList"] = invoiceArray;
                    console.log(elementMain);
                  }

                  console.log(
                    "Sline payment details => ",
                    this.FFExportNew.length
                  );
                } else {
                  elementMain["invNo"] = "";
                  elementMain["invType"] = "";

                  this.FFExportNew.push(elementMain);
                }
              });
            } else {
              this.FFExport = [];
              this.FFExportNew = [];
            }

            this.totalCount = parseInt(data.totalCount);
            this.totalCompleted = parseInt(data.totalCompleted);
            this.totalVGMSubCount = parseInt(data.totalVGMSubCount);
            this.totalGateInCount = parseInt(data.totalGateInCount);
            this.totalHandoverCount = parseInt(data.totalHandoverCount);
            this.totalRailCount = parseInt(data.totalRailCount);
            this.totalSailCount = parseInt(data.totalSailCount);
            this.totalSICount = parseInt(data.totalSICount);
            this.totalBLCount = parseInt(data.totalBLCount);
            this.bookPageId = data.SEA_FRGHT_Booking;
            this.execPageId = data.SEA_FRGHT_EXEC;
            this.vgmPageId = data.SEA_FRGHT_VGM;
            this.handoverPageId = data.SEA_FRGHT_RAIL;
            this.sailPageId = data.SEA_FRGHT_SAIL;
            this.ladingPageId = data.SEA_FRGHT_BLADING;
            // this.JqueryFun();
            this.isLoading = false;
            //
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.colwidth {
  min-width: 200px !important;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// slinePaymentDetailsNew.vue?61170b88